/**
 * User: itaik
 * Date: 6/26/13
 * Responsible to manage menu and tray items.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");
    var TopLevelMenuItemModel = require("models/top-level-menu/TopLevelMenuItemModel");
    var TopLevelMenuStatusItemModel = require("models/top-level-menu/TopLevelMenuStatusItemModel");
    var TrayMenuItemModel = require("models/TrayMenuItemModel");

    var BarMenu = (function () {
        var userBarMenuAPI = {
            statusCollection:new Backbone.Collection(),
            menuCollection:new Backbone.Collection(),
            trayCollection:new Backbone.Collection()
        };

        userBarMenuAPI.statusCollection.comparator = "index";

        userBarMenuAPI.trayCollection.comparator = "index";

        /**
         * @param topLevelMenuItemModel
         * @param [optional] index to splice the menu item into the item collection
         */
        userBarMenuAPI.addMenuItem = function (topLevelMenuItemModel, index) {
            var options = isValidIndex(userBarMenuAPI.menuCollection, index) ? {at: index} : {};
            userBarMenuAPI.menuCollection.add(topLevelMenuItemModel, options);
        };
        userBarMenuAPI.addTrayItem = function (trayMenuItemModel) {
            userBarMenuAPI.trayCollection.add(trayMenuItemModel);
        };
        userBarMenuAPI.removeMenuItem = function (topLevelMenuItemModel) {
            userBarMenuAPI.menuCollection.remove(topLevelMenuItemModel);
        };
        userBarMenuAPI.removeTrayItem = function (trayMenuItemModel) {
            userBarMenuAPI.trayCollection.remove(trayMenuItemModel);
        };

        userBarMenuAPI.addStatusItem = function (topLevelMenuStatusItem, index) {
            topLevelMenuStatusItem.setIndex(index);
            userBarMenuAPI.statusCollection.add(topLevelMenuStatusItem);
        };
        userBarMenuAPI.removeStatusItem = function (topLevelMenuStatusItem) {
            userBarMenuAPI.statusCollection.remove(topLevelMenuStatusItem);
        };
        userBarMenuAPI.setCurrentStatusItem = function(topLevelMenuStatusItem, reasonId) {
            var selectedModel = userBarMenuAPI.statusCollection.find(topLevelMenuStatusItem);
            if (selectedModel) {
                userBarMenuAPI.statusCollection.each(function(model){
                    var isSelectedModel = selectedModel === model;
                    var title = model.getAvailabilityTitle();

                    if (isSelectedModel) {
                        model.setSelectedReason(reasonId);

                        var customReasons = model.getCustomReasons();
                        if (customReasons) {
                            var reasonModel = customReasons.findWhere({id: reasonId});
                            if (reasonModel) {
                                title = reasonModel.get("text");
                            }
                        }

                        var chatAvailabilityTrayItem = userBarMenuAPI.trayCollection.findWhere({type:TrayMenuItemModel.TYPES.AVAILABILITY});
                        if (chatAvailabilityTrayItem) {
                            chatAvailabilityTrayItem.setTooltip(title);
                        }
                    }
                    else {
                        model.unset(model.KEYS.SELECTED_REASON);
                    }

                    model.setSelected(isSelectedModel);
                    model.setTitle(title);
                });
            }
        };
        userBarMenuAPI.getCurrentStatusItem = function() {
            return userBarMenuAPI.statusCollection.findWhere({selected: true});
        };
        userBarMenuAPI.redrawCurrentStatusItem = function() {
            var currentStatusItem = userBarMenuAPI.getCurrentStatusItem();

            if (currentStatusItem) {
                var reasonId = currentStatusItem.getSelectedReason();
                userBarMenuAPI.setCurrentStatusItem(currentStatusItem, reasonId);
            }
        };

        function isValidIndex(collection, index) {
            //return !_.isUndefined(index) && (collection.length >= index);
            return (!_.isUndefined(index) && !isNaN(index));
        }

        return userBarMenuAPI;
    })();

    // Expose modelsrrrun
    BarMenu.TopLevelMenuItemModel = TopLevelMenuItemModel;
    BarMenu.TopLevelMenuStatusItemModel = TopLevelMenuStatusItemModel;
    BarMenu.TrayMenuItemModel = TrayMenuItemModel;

    return BarMenu;
});
